import React from "react";
import { Button, Modal } from "react-bootstrap";
import newLogo from "../../assets/new_logo.png";

const InvestorRedirectModal = (props) => {
  const close = () => {
    props.setActive(false);
  };
  const navigate = (target) => {
    console.log();
    close();
    if (target === "POLICY_CENTER") window.location.href = "/policycenter";
    if (target === "REQUEST_TRACKER")
      window.location.href = "/assignmenttracker";
  };
  return (
    <div>
      <Modal
        show={props.active}
        centered
        onHide={() => {
          props.setActive(false);
        }}
      >
        {/* <Modal.Header closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header> */}
        <Modal.Body>
          <div className="row">
            <div className="col-5 d-flex justify-content-center">
              {" "}
              <img src={newLogo} alt="" height={130}></img>
            </div>
            <div className="col-7  align-self-center" style={{fontSize:"24px", textAlign:"center"}}>
              <b>You do not have any assigned policies</b>
              <p className="font-weight-light ">
                <small></small>
              </p>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            className="px-5 py-2 mx-1"
            variant="outline-primary"
            onClick={() => {
              navigate("REQUEST_TRACKER");
            }}
          >
            In Progress
          </Button>
          <Button
            className="mx-1 px-4 py-2"
            onClick={() => {
              navigate("POLICY_CENTER");
            }}
          >
            New  Investment
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default InvestorRedirectModal;
